import React from "react";
import { Box, Typography } from "@mui/material";
import DogGrooming from "../../assets/images/dogGrooming.jpg";
import Clip from "../../assets/images/clip.svg";
import { useOutletContext } from "react-router-dom";

const darkPatternURL =
  "https://www.transparenttextures.com/patterns/asfalt-dark.png";

export default function About() {
  const [color, setColor] = useOutletContext();
  //setColor(true);
  return (
    <Box sx={{ overflow: "hidden" }}>
      <Box
        sx={{
          overflow: "auto",
          marginTop: { xs: "230px", md: 0 },
          height: { md: "100dvh", xs: "calc(100dvh - 230px)" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column", // mobile
              md: "row", // desktop and up
            },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              height: "100vh",
              borderRadius: { xs: "20px 20px 0 0", md: "0px" },
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${DogGrooming})`,
              backgroundSize: "auto 100%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              position: { xs: "relative", md: "static" },
            }}
          >
            <Box
              sx={{
                position: { xs: "absolute", md: "fixed" },
                bottom: { md: "170px", xs: "290px" },
                right: { xs: 0, md: " 50%" },

                background: "#ffffff",
                borderRadius: "10px 0 0 10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "20px 0",
                //justifyContent:"flex-end"
              }}
            >
              <Box
                sx={{
                  height: { xs: "40px", md: "50px", lg: "60px" },
                  display: "flex",
                  margin: "0 30px",
                }}
              >
                <img src={Clip} alt="Clip" />
              </Box>
              <Box
                sx={{
                  fontSize: { xs: "18px", md: "24px", lg: "30px" },
                  fontWeight: 800,
                  color: "#F04336",
                  paddingRight: "20px",
                }}
              >
                " We Style, They Smile! "
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              flexDirection: "column",
              height: { xs: "auto", sm: "100vh" },
              justifyContent: "center",
              alignItems: "left",
              backgroundColor: "#F04336",
              backgroundImage: `url(${darkPatternURL})`,
            }}
          >
            <Box
              sx={{
                textAlign: "left",
                fontSize: "65px",
                display: "inline-block",
                fontWeight: "800",
                position: "relative",
                color: "white",
                marginBottom: "30px",
                padding: { xs: "0px 20px", md: "0px 80px" },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  left: 80,
                  bottom: 0,
                  height: "7px", // underline thickness
                  width: "50px", // control underline width here
                  backgroundColor: "white",
                  borderRadius: "8px",
                },
              }}
            >
              About Us
            </Box>
            <Box
              sx={{
                color: "white",
                marginRight: { xs: "20px", md: "80px" },
                textAlign: "left",
                fontSize: "20px",
                backgroundColor: "#DD3528",
                backgroundImage: `url(${darkPatternURL})`,
                padding: { xs: "0px 20px", md: "30px 50px 30px 80px" },
                overflow: "auto",
              }}
            >
              Hi, I'm Kimberly - a fully qualified dog groomer and certified in
              pet first aid. I'm also a proud fur mum to five beautiful dogs:
              three Springer Spaniels (Bella, Bonnie, and Piddles), a Dogue de
              Bordeaux named Shadow, and an American bulldog called Paws. With
              such a lively pack, I know all too well how hard it can be to keep
              our furry friends clean and smelling fresh, especially when they
              seem to seek out every puddle and muddy patch they can find!
              <br />
              My passion for animals and hands-on experience inspired me to turn
              that daily challenge into a rewarding business. We've transformed
              our conservatory into a warm, cosy, and welcoming dog grooming
              salon. It features a comfortable waiting area if you'd like to
              stay while your pup gets pampered, plus top-of-the-line grooming
              equipment and deliciously scented products to keep your fur babies
              looking and feeling their best.
              <br />
              I’m here to provide a top-quality, loving, and stress-free
              grooming experience for your beloved pets-treating them with the
              same care and attention I give my own.
              <Typography sx={{ paddingTop: "20px" }} variant="h5">
                {" "}
                <span style={{ fontWeight: 800, fontFamily: "Nunito" }}>
                  - Kimberly
                </span>{" "}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
